import {primaryColor} from "assets/jss/material-dashboard-pro-react.jsx";

const accordionStyle = theme => ({
  root: {
    flexGrow: 1
  },
  expansionPanel: {
    boxShadow: "none",
    "&:before": {
      display: "none !important"
    }
  },
  expansionPanelExpanded: {
    margin: "0!important"
  },
  expansionPanelSummary: {
    minHeight: "auto !important",
    backgroundColor: "transparent",
    borderBottom: "1px solid #ddd",
    padding: "5px 14px 5px 0px",
    borderTopLeftRadius: "3px",
    borderTopRightRadius: "3px",
    color: "#3C4858",
    "&:hover": {
      color: primaryColor
    },
    "& .actions": {
      display: "inline-block",
      opacity: 0,
      transition: "all 0.3s",
      pointerEvents: "none"
    }
  },
  expansionPanelSummaryExpaned: {
    color: primaryColor,
    "& $expansionPanelSummaryExpandIcon": {
      [theme.breakpoints.up("md")]: {
        top: "auto !important"
      },
      transform: "rotate(180deg)",
      [theme.breakpoints.down("sm")]: {
        top: "auto !important"
      }
    },
    "& .actions": {
      opacity: 1,
      pointerEvents: "initial"
    }
  },
  expansionPanelSummaryContent: {
    margin: "0 !important",
    justifyContent: "space-between"
  },
  expansionPanelSummaryExpandIcon: {
    padding: 5,
    [theme.breakpoints.up("md")]: {
      top: "auto !important"
    },
    transform: "rotate(0deg)",
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      top: "auto !important"
    }
  },
  expansionPanelSummaryExpandIconExpanded: {},
  title: {
    lineHeight: "30px",
    fontSize: "15px",
    fontWeight: "bolder",
    marginTop: "0",
    marginBottom: "0",
    color: "inherit",
    display: "inline",
    flex: 1,
  },
  secondaryTitle: {
    color: "#8a8a8a",
    fontSize: "15px",
    display: "inline-flex",
    marginRight: "15px",
    marginLeft: 10,
    marginTop: "0",
    marginBottom: "0",
    lineHeight: "30px",
    //flex: 1,
    textAlign: "right"
  },
  expansionPanelDetails: {
    padding: "15px 0px 5px",
    display: "block"
  },
  panelActions: {
    height: "30px",
    marginTop: "-14px"
  }
});

export default accordionStyle;
